// TODO: Provide a sensible implementation

import * as React from "react"
import { Container, Row } from "./library/container"

import { LinkButton } from "./library/button"

interface ErrorProps {}

interface ErrorState {}

export class Error extends React.Component<ErrorProps, ErrorState> {
  constructor(props: ErrorProps) {
    super(props)
  }

  render() {
    return (
      <Container>
        <Row>
          <div className="error__wrapper">
            <h2>Helaas</h2>
            <p className="error__text">Deze pagina kan niet worden getoond.</p>
            <LinkButton route={"/"}>Terug naar de homepage</LinkButton>
          </div>
        </Row>
      </Container>
    )
  }
}

export const AanZetErrorElement = <Error />